import { z } from 'zod';

export const documentUploadResponseSchema = z.object({
    document: z.object({
        id: z.string(),
        user_id: z.string(),
        name: z.string(),
        type: z.string().trim().min(1),
        mime_type: z.string(),
        status: z.string().trim().min(1),
    }),
    upload_url: z.string().url(),
});

export type DocumentUploadResponse = z.infer<typeof documentUploadResponseSchema>;
